import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getStoreOnlineAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/store-online', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getStoreOnlineById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/store-online/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createStoreOnline = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/store-online`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateStoreOnline = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/store-online/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteStoreOnline = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/store-online/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteStoreOnline = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/store-online/${id}`);
    return handleResponse(response, onSuccess, onError);
};